import PropTypes from 'prop-types';
import { Position } from '@xyflow/react';
import { Stack } from '@mui/material';
import { useIntl } from 'react-intl';
import { BaseNode } from 'pages/assistants/builder/components/nodes/baseNode';
import { CompactNodeField } from 'pages/assistants/builder/components/nodes/compactNodeField';
import { useGetKnowledgeBasesQuery } from 'services/knowledgeBaseApi';
import IndeterminateLoading from 'components/Loading/IndeterminateLoading';
import { useNotification } from 'hook/useNotification';

export function KnowledgeBaseNode({
  id,
  data = {
    knowledgeBaseId: '0',
    label: 'Base de connaissance'
  },
  onEditNode,
  onDeleteNode
}) {
  const { addNotification } = useNotification();
  const { formatMessage: msg } = useIntl();

  const {
    data: knowledgeBases = [],
    isLoading: knowledgeBasesLoading,
    isError: knowledgeBaseError
  } = useGetKnowledgeBasesQuery();

  if (knowledgeBaseError) {
    try {
      addNotification({
        type: 'error',
        title: msg({ id: 'notification.warning.title' }),
        message: msg({ id: 'page.advisor.fetch.error' })
      });
    } catch {
      // ignore
    }
  }

  const selectedKB = knowledgeBases.find((kb) => kb.id === Number(data?.knowledgeBaseId)) || null;

  return (
    <BaseNode
      id={id}
      icon="school"
      nodeData={{ ...data, label: selectedKB?.label || 'Base de connaissance' }}
      color="dark"
      handleConf={[{ type: 'source', position: Position.Top, style: { background: '#334667' } }]}
      onDeleteNode={onDeleteNode}
      onEditNode={onEditNode}
    >
      <Stack spacing={1} sx={{ p: 1, width: '350px' }}>
        {knowledgeBasesLoading ? (
          <IndeterminateLoading />
        ) : (
          <>
            <CompactNodeField
              label={msg({ id: 'field.knowledgeBase.label' })}
              value={selectedKB ? `${selectedKB.code} (${selectedKB.label})` : 'Aucune'}
            />
          </>
        )}
      </Stack>
    </BaseNode>
  );
}

KnowledgeBaseNode.propTypes = {
  id: PropTypes.string,
  data: PropTypes.shape({
    id: PropTypes.string,
    knowledgeBaseId: PropTypes.string,
    label: PropTypes.string
  }),
  onEditNode: PropTypes.func.isRequired,
  onDeleteNode: PropTypes.func.isRequired
};
